module.exports = "/_next/static/images/d1411211ac219546bee3d2cb0dfc3624-cristina-desktop.jpg.webp";